export default __webpack_public_path__ + "img/c3eb8923f3b8363cc035f60d88b41643.png";